export default "__VITE_ASSET__4ikOcno$__"